import type { SVGProps } from 'react';

const SvgCase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M20 6.428a2 2 0 0 1 2 2v1.654a2 2 0 0 1-1.426 1.916l-7.425 2.228a4 4 0 0 1-2.298 0l-7.425-2.228A2 2 0 0 1 2 10.082V8.428a2 2 0 0 1 2-2zm-8 2.678a.75.75 0 0 0-.75.75v1.714l.004.078a.75.75 0 0 0 1.492 0l.004-.078V9.856a.75.75 0 0 0-.75-.75"
    />
    <path
      fill="#000"
      d="M21.917 17a4.75 4.75 0 0 1-4.75 4.75H6.833A4.75 4.75 0 0 1 2.084 17v-3.991c.277.181.581.329.91.428l7.425 2.227c1.031.31 2.13.31 3.162 0l7.424-2.227c.33-.1.634-.247.912-.428zm-.064-6.168c-.223.55-.684.989-1.278 1.167l-7.426 2.228a4 4 0 0 1-2.298 0l-7.426-2.228a2 2 0 0 1-1.279-1.167l9.855 1.668z"
    />
    <path
      stroke="#000"
      strokeWidth={1.5}
      d="M15.333 6.429V5a2 2 0 0 0-2-2h-2.667a2 2 0 0 0-2 2v1.429"
    />
  </svg>
);
export default SvgCase;
